export default __webpack_public_path__ + "static/media/p1_token.2dd43301.png";